module.exports = __webpack_public_path__ + "static/startup-a6a10f1738eccf1affff2656ddcd5b9e.mp4";